import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Checkbox, FormControlLabel, Button, Grid } from '@material-ui/core';

const AddMark = ({ open, onClose, addMark, saveMark, stageRef, markData }) => {
    const [x, setX] = useState('');
    const [y, setY] = useState('');
    const [step, setStep] = useState(3);
    const [snap, setSnap] = useState(false);
    const [show, setShow] = useState(true);
    const [rings, setRings] = useState(25);
    const [resetCenter, setResetCenter] = useState(false);
    const [hasInitialized, setHasInitialized] = useState(false);

    useEffect(() => {
        if ((open && stageRef.current && resetCenter) || !hasInitialized) {
            const stage = stageRef.current;
            const stageWidth = stage.attrs.width || 0;
            const stageHeight = stage.attrs.height || 0;
            const stageScaleX = stage.attrs.scaleX || 1;
            const stageScaleY = stage.attrs.scaleY || 1;
            const stageX = stage.attrs.x || 0;
            const stageY = stage.attrs.y || 0;

            setX(Math.round(((stageWidth / 2 - stageX) / stageScaleX) * 100) / 100);
            setY(Math.round(((stageHeight / 2 - stageY) / stageScaleY) * 100) / 100);
            setResetCenter(false)
        }
    }, [resetCenter, stageRef, open, hasInitialized]);

    useEffect(() => {
        setX(Math.round(markData.x * 100) / 100);
        setY(Math.round(markData.y * 100) / 100);
    }, [markData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            if (name === 'show') {
                setShow(checked);
            }
            if (name === 'snap') {
                setSnap(checked);
            }
        } else {
            if (!isNaN(value) || value === '') {
                if (name === 'rings') setRings(value);
                if (name === 'x') setX(value);
                if (name === 'y') setY(value);
                if (name === 'step') setStep(value);
            }
        }
    };

    const generateRingPoints = (centerX, centerY, step, rings, numPoints = 36) => {
        const points = [];
        
        for (let i = 0; i < rings; i++) {
            const radius = step * (i + 1);
    
            const pointsForCurrentRing = Math.min(Math.max(Math.floor(2 * Math.PI * radius / (2 * Math.PI / numPoints)), 36), 400);
            
            for (let j = 0; j < pointsForCurrentRing; j++) {
                const angle = (2 * Math.PI * j) / pointsForCurrentRing; 
                const px = centerX + radius * Math.cos(angle);
                const py = centerY + radius * Math.sin(angle);
                points.push({ x: parseFloat(px.toFixed(2)), y: parseFloat(py.toFixed(2)) });
            }
        }    
        points.push({ x: centerX, y: centerY });
        
        return points;
    };
    


    const handleSubmit = () => {
        const parsedX = parseFloat(x);
        const parsedY = parseFloat(y);
        const parsedStep = parseFloat(step);
        const parsedRings = parseInt(rings, 10);

        const markData = {
            x: parsedX,
            y: parsedY,
            step: parsedStep,
            snap,
            show,
            rings: parsedRings,
            points: generateRingPoints(parsedX, parsedY, parsedStep, parsedRings),
        };

        if (!hasInitialized) {
            addMark(markData);
            setHasInitialized(true);
            onClose();
        }
        else {
            saveMark(markData);
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Add Mark</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={show}
                                    onChange={handleChange}
                                    name="show"
                                    color="primary"
                                />
                            }
                            label="Show Mark"
                        />
                    </Grid>

                    <Grid item xs={4.5}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="X"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={x}
                            onChange={handleChange}
                            name="x"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>
                    <Grid item xs={4.5}>
                        <TextField
                            margin="dense"
                            label="Y"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={y}
                            onChange={handleChange}
                            name="y"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>
                    <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setResetCenter(true)}
                            style={{
                                minHeight: '40px',
                                padding: '6px 16px'
                            }}
                        >
                            Recenter
                        </Button>
                    </Grid>

                    <Grid item xs={4.5}>
                        <TextField
                            margin="dense"
                            label="Step"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={step}
                            onChange={handleChange}
                            name="step"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>

                    <Grid item xs={4.5}>
                        <TextField
                            margin="dense"
                            label="Number of Rings"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={rings}
                            onChange={handleChange}
                            name="rings"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={snap}
                                    onChange={handleChange}
                                    name="snap"
                                    color="primary"
                                />
                            }
                            label="Snap"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button onClick={handleSubmit} color="primary">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddMark;
